import { render, staticRenderFns } from "./portrait.vue?vue&type=template&id=6b5436b3&scoped=true&"
import script from "./portrait.vue?vue&type=script&lang=js&"
export * from "./portrait.vue?vue&type=script&lang=js&"
import style0 from "./portrait.vue?vue&type=style&index=0&id=6b5436b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5436b3",
  null
  
)

export default component.exports